export default __webpack_public_path__ + "static/media/geekgirls.a4007297.png";